<template>
    <ModalTemplate :showModal="isModalActive" :width="widthModal" @closeModal="closeModal">
        <template v-slot:headerModal>
            <div class="is-flex is-justify-content-space-between is-align-items-center">
                <div class="is-flex is-justify-content-space-between is-align-items-center">
                    <LaporanIcon class="mr-2" />
                    <p class="averta-bold label-18">
                        {{ typeModal === 'paid' ? 'Preview Invoice ID: ' : 'Preview Tagihan Invoice ID: ' }}{{ dataModal?.survey_id }}
                    </p>
                </div>
                <div class="is-clickable" @click="closeModal">
                    <b-icon icon="close"></b-icon>
                </div>
            </div>
        </template>
        <template v-slot:bodyModal>
            <div class="invoice-wrapper">
                <!-- <div class="invoice-container"> -->
                <!-- Content -->
                <div class="invoice-content">
                    <!-- Total Paid -->
                    <div class="total-paid-box">
                        <div class="is-flex is-align-items-center">
                            <b-icon icon="wallet" size="is-small" class="has-text-success mr-3"></b-icon>
                            <span class="total-label">Total Yang Dibayarkan</span>
                        </div>
                        <span class="total-amount averta-black">{{
                            formatThousand(dataModal?.installments?.[selectedPhase - 1]?.grand_total) }}</span>
                    </div>

                    <div class="section">
                        <div class="is-flex is-justify-content-space-between section-title">
                            <span>No. Invoice</span>
                            <div class="invoice-number-input-wrapper"
                                v-if="!dataModal?.installments?.[selectedPhase - 1]?.invoice_number">
                                <input v-model="invoiceNumber" type="text" class="invoice-number-input"
                                    :class="{ 'error': showError || (!invoiceNumber && invoiceNumber !== null) }"
                                    placeholder="Masukkan nomor invoice" @input="showError = false" />
                                <span v-if="showError" class="error-tooltip">Harap isi Invoice Number</span>
                            </div>
                            <span v-else>
                                {{ dataModal?.installments?.[selectedPhase - 1]?.invoice_number }}
                            </span>
                        </div>
                    </div>

                    <!-- Order Details -->
                    <div class="section">
                        <h2 class="section-title">Rincian Pesanan</h2>
                        <p class="section-date">{{ dataModal?.date }}</p>

                        <div class="detail-list">
                            <div class="is-flex is-justify-content-space-between detail-header">
                                <span>Deskripsi</span>
                                <span>Total</span>
                            </div>

                            <div class="detail-item">
                                <div class="is-flex is-justify-content-space-between mb-1">
                                    <span class="detail-desc">Pekerjaan Atas Nomor Penawaran</span>
                                    <span class="detail-price">{{ formatThousand(dataModal?.grand_total) }}</span>
                                </div>
                                <p class="detail-order-number">{{ dataModal?.offering_number }}</p>
                            </div>

                            <div class="is-flex is-justify-content-space-between detail-row">
                                <span class="detail-desc">Harga Jual</span>
                                <span class="detail-price">{{ formatThousand(dataModal?.grand_total) }}</span>
                            </div>
                            <div v-if="dataModal?.installments?.[selectedPhase - 1]?.payment_paid !== 0"
                                class="is-flex is-justify-content-space-between detail-row">
                                <span class="detail-desc">Telah Dibayar</span>
                                <span class="detail-discount">-{{
                                    formatThousand(dataModal?.installments?.[selectedPhase - 1]?.payment_paid) }}</span>
                            </div>

                            <div class="is-flex is-justify-content-space-between detail-row">
                                <span class="detail-desc">
                                    Pembayaran
                                    <span v-if="dataModal?.installments?.length === 1">
                                        Penuh
                                    </span>
                                    <span v-else-if="selectedPhase === 1">
                                        Termin 1 (DP)
                                    </span>
                                    <span v-else-if="selectedPhase === dataModal?.installments?.length">
                                        Pelunasan
                                    </span>
                                    <span v-else>
                                        Termin {{ selectedPhase }}
                                    </span>
                                </span>
                                <span class="detail-discount">-{{
                                    formatThousand(dataModal?.installments?.[selectedPhase - 1]?.installment_amount)
                                    }}</span>
                            </div>
                            <div class="is-flex is-justify-content-space-between detail-total">
                                <span class="detail-total-label">Sisa Pembayaran</span>
                                <span class="detail-total-amount">{{
                                    formatThousand(dataModal?.installments?.[selectedPhase - 1]?.outstanding_amount)
                                    }}</span>
                            </div>
                        </div>
                    </div>

                    <!-- Payment Details -->
                    <div class="section-payment">
                        <h2 class="section-title">Detail Pembayaran</h2>
                        <div class="payment-box">
                            <div class="is-flex is-justify-content-space-between payment-row">
                                <span class="payment-label">Sub Total</span>
                                <span class="payment-value">{{
                                    formatThousand(dataModal?.installments?.[selectedPhase - 1]?.installment_amount)
                                    }}</span>
                            </div>

                            <div class="is-flex is-justify-content-space-between payment-row">
                                <span class="payment-label">Biaya Admin</span>
                                <span class="payment-value">{{
                                    formatThousand(dataModal?.installments?.[selectedPhase - 1]?.installment_fee)
                                    }}</span>
                            </div>

                            <div class="is-flex is-justify-content-space-between payment-total">
                                <span class="payment-total-label">Grand Total</span>
                                <span class="payment-total-value">{{
                                    formatThousand(dataModal?.installments?.[selectedPhase - 1]?.grand_total) }}</span>
                            </div>

                            <div class="payment-divider"></div>

                            <div class="is-flex is-justify-content-space-between payment-row">
                                <span class="payment-label" style="text-transform: capitalize;">Biaya {{
                                    dataModal?.installments?.[selectedPhase - 1]?.payment_name }}</span>
                                <span class="payment-value">{{
                                    formatThousand(dataModal?.installments?.[selectedPhase - 1]?.payment_fee) }}</span>
                            </div>

                            <div class="is-flex is-justify-content-space-between payment-final">
                                <span class="payment-final-label">Total Pembayaran</span>
                                <div class="payment-final-value">
                                    <span v-if="dataModal?.installments?.[selectedPhase - 1]?.status !== null"
                                        class="payment-status" :class="{
                                            'status-pending': dataModal?.installments?.[selectedPhase - 1]?.status === 'PENDING',
                                            'status-paid': dataModal?.installments?.[selectedPhase - 1]?.status === 'PAID',
                                            'status-expired': dataModal?.installments?.[selectedPhase - 1]?.status === 'EXPIRED',
                                            'status-cancelled': dataModal?.installments?.[selectedPhase - 1]?.status === 'CANCELLED'
                                        }">[{{ dataModal?.installments?.[selectedPhase - 1]?.status || "PENDING"
                                    }}]</span>
                                    <span class="payment-amount">{{
                                        formatThousand(dataModal?.installments?.[selectedPhase - 1]?.total_payment)
                                        }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="section-description mt-2">
                        <div class="payment-box detail-description">
                            <span>
                                Pembayaran maksimal dilaksanakan 3 hari terhitung dari tanggal penerimaan tagihan.
                            </span>
                            <span>
                                Pembayaran dapat ditransfer ke rekening:
                            </span>
                            <span>
                                PT Tenaga Kanggo Indonesia
                            </span>
                            <span>
                                BCA KCU Serpong
                            </span>
                            <div>
                                <span>
                                    No rekening:
                                </span>
                                <span class="averta-black">
                                    4978888397
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- </div> -->
            </div>
            <div class="form-button is-flex is-justify-content-end is-align-items-center gap-2"
                :class="{ 'active': true }">
                <b-button @click="downloadPDF" :loading="isLoading" class="btn-outline-red">
                    Unduh Invoice
                </b-button>

                <b-button @click="handleSendInvoice" :loading="isLoading" class="btn-fill-red"
                    v-if="!dataModal?.installments?.[selectedPhase - 1]?.invoice_number">
                    {{ (dataModal?.installments?.[selectedPhase - 1]?.status === 'PAID' &&
                        !dataModal?.installments?.[selectedPhase - 1]?.invoice_number) ||
                        (dataModal?.installments?.[selectedPhase - 1]?.status === 'PENDING' &&
                            !dataModal?.installments?.[selectedPhase - 1]?.invoice_number) ? 'Edit Nomor Invoice' : 'Kirim Invoice' }}
                </b-button>
            </div>
        </template>
    </ModalTemplate>
</template>

<script>
/* eslint-disable */
import moment from 'moment'
import { mapGetters } from 'vuex'
import { LaporanIcon } from '@/components/icons'
import ModalTemplate from './ModalTemplate.vue'
import saveImage from '@/assets/img/delete-area-component.png'
import jsPDF from 'jspdf'
import html2canvas from 'html2canvas'
import {
    formatCurrencyReturnZero as formatCurrency
} from '@/helpers'

const logoUrl = require('@/assets/img/logo-kanggo-2.png')

export default {
    name: 'ModalInvoiceTagihan',
    components: { ModalTemplate, LaporanIcon },
    props: {
        showModal: {
            type: Boolean,
            default: false
        },
        width: {
            type: String,
            default: '75vw'
        },
        dataModal: {
            type: Object,
            default: () => ({})
        },
        selectedPhase: {
            type: Number,
            default: 0
        },
        typeModal: {
            type: String,
            default: ''
        }
    },
    computed: {
        ...mapGetters({
            url: 'setup/getUrl'
        })
    },
    data() {
        console.log('dataModal invoice modal:', this.dataModal, this.selectedPhase)
        return {
            isModalActive: false,
            widthModal: this.width,
            isLoading: false,
            invoiceData: this.dataModal,
            installmentId: this.selectedPhase,
            type: this.typeModal,
            invoiceNumber: this.dataModal?.invoice_number || null,
            showError: false
        }
    },
    methods: {
        closeModal() {
            this.$emit('closeModal')
        },
        generateTermin() {
            this.$emit('generateTermin', this.invoiceData.survey_id, this.installmentId, this.invoiceNumber, this.invoiceData?.installments?.[this.installmentId - 1]?.status)
        },
        formatThousand(amount) {
            return formatCurrency(amount)
        },
        handleSendInvoice() {
            // Validasi nomor invoice
            if (!this.invoiceNumber || this.invoiceNumber.trim() === '') {
                this.showError = true
                return
            }

            this.$swal({
                imageUrl: saveImage,
                imageAlt: 'send invoice',
                width: '540px',
                padding: '10px 10px 30px 10px',
                title: '<p class="averta-bold label-22">Kirim Invoice</p>',
                html: '<p>Pastikan kamu sudah cek kembali seluruh informasi telah benar dan sesuai</p>',
                showCancelButton: true,
                confirmButtonText: 'Kirim Invoice',
                cancelButtonText: 'Batalkan',
                reverseButtons: true,
                customClass: {
                    confirmButton: 'btn-hapus-detail-component',
                    cancelButton: 'btn-batal-detail-component'
                }
            }).then((result) => {
                if (result.isConfirmed) {
                    this.generateTermin()
                    this.closeModal()
                }
            })
        },
        /* eslint-disable new-cap */
        async downloadPDF() {
            if (this.isLoading) return

            this.isLoading = true

            try {
                // Ambil element invoice-wrapper yang berisi seluruh konten
                const wrapper = document.querySelector('.invoice-wrapper')

                if (!wrapper) {
                    this.$buefy.toast.open({
                        message: 'Element invoice tidak ditemukan',
                        type: 'is-danger',
                        position: 'is-top'
                    })
                    this.isLoading = false
                    return
                }

                // Simpan scroll position dan height original
                const originalOverflow = wrapper.style.overflow
                const originalMaxHeight = wrapper.style.maxHeight

                // Temporarily remove scroll to capture full content
                wrapper.style.overflow = 'visible'
                wrapper.style.maxHeight = 'none'

                // Handle invoice number input/display
                const invoiceInputWrapper = document.querySelector('.invoice-number-input-wrapper')
                let tempInvoiceDisplay = null
                let originalInputWrapper = null

                if (invoiceInputWrapper) {
                    originalInputWrapper = invoiceInputWrapper.cloneNode(true)

                    // Buat element pengganti untuk PDF
                    tempInvoiceDisplay = document.createElement('span')
                    tempInvoiceDisplay.className = 'invoice-number-display'

                    if (this.invoiceNumber && this.invoiceNumber.trim() !== '') {
                        // Jika ada nomor invoice, tampilkan sebagai text biasa
                        tempInvoiceDisplay.textContent = this.invoiceNumber
                        tempInvoiceDisplay.style.cssText = 'font-size: 16px; font-weight: bold; color: #1a1a1a;'
                    } else {
                        // Jika tidak ada, tampilkan pesan error merah
                        tempInvoiceDisplay.textContent = 'Nomor Invoice Belum Diisi'
                        tempInvoiceDisplay.style.cssText = 'font-size: 16px; font-weight: bold; color: #dc3545;'
                    }

                    // Replace input wrapper dengan text display
                    invoiceInputWrapper.parentNode.replaceChild(tempInvoiceDisplay, invoiceInputWrapper)
                }

                // Preload logo image
                const logoImg = new Image()
                logoImg.crossOrigin = 'anonymous'
                logoImg.src = logoUrl

                // Wait for logo to load
                await new Promise((resolve, reject) => {
                    logoImg.onload = resolve
                    logoImg.onerror = reject
                })

                // Tambahkan header logo untuk PDF
                const headerDiv = document.createElement('div')
                headerDiv.className = 'pdf-header-logo'
                headerDiv.style.cssText = 'padding: 20px 20px 10px 20px; background-color: #ffffff;'

                const imgElement = document.createElement('img')
                imgElement.src = logoImg.src
                imgElement.alt = 'logo'
                imgElement.style.cssText = 'max-width: 150px; height: auto; display: block;'

                headerDiv.appendChild(imgElement)

                // Insert header di awal wrapper
                wrapper.insertBefore(headerDiv, wrapper.firstChild)

                // Wait untuk render
                await new Promise(resolve => setTimeout(resolve, 200))

                // Capture element sebagai canvas dengan kualitas tinggi
                const canvas = await html2canvas(wrapper, {
                    scale: 2,
                    allowTaint: false,
                    useCORS: true,
                    backgroundColor: '#ffffff',
                    logging: false,
                    scrollY: -window.scrollY,
                    scrollX: -window.scrollX,
                    windowWidth: wrapper.scrollWidth,
                    windowHeight: wrapper.scrollHeight
                })

                // Remove header setelah capture
                wrapper.removeChild(headerDiv)

                // Restore original styles
                wrapper.style.overflow = originalOverflow
                wrapper.style.maxHeight = originalMaxHeight

                // Hitung dimensi untuk PDF (A4 size)
                const imgWidth = 210 // A4 width in mm
                const imgHeight = (canvas.height * imgWidth) / canvas.width
                const pageHeight = 297 // A4 height in mm

                // Convert canvas to image
                const imgData = canvas.toDataURL('image/jpeg', 1.0)

                // Create PDF
                const pdf = new jsPDF('p', 'mm', 'a4')
                let heightLeft = imgHeight
                let position = 0

                // Add first page
                pdf.addImage(imgData, 'JPEG', 0, position, imgWidth, imgHeight)
                heightLeft -= pageHeight

                // Add additional pages if content is longer than one page
                while (heightLeft > 0) {
                    position = heightLeft - imgHeight
                    pdf.addPage()
                    pdf.addImage(imgData, 'JPEG', 0, position, imgWidth, imgHeight)
                    heightLeft -= pageHeight
                }

                // Generate filename
                const filename = `Invoice_${this.dataModal?.survey_id || 'INV'}_${this.invoiceNumber || 'DRAFT'
                    }_${moment().format('DDMMYYYY')}.pdf`

                // Save PDF
                pdf.save(filename)

                this.$buefy.toast.open({
                    message: 'Invoice berhasil diunduh',
                    type: 'is-success',
                    position: 'is-top'
                })
            } catch (error) {
                console.error('Error generating PDF:', error)
                this.$buefy.toast.open({
                    message: 'Gagal mengunduh invoice: ' + error.message,
                    type: 'is-danger',
                    position: 'is-top'
                })
            } finally {
                this.isLoading = false
            }
        },
        /* eslint-enable new-cap */
        async captureContent(selector, pdf) {
            const element = document.querySelector(selector)
            return html2canvas(element, { scale: 2, allowTaint: true, useCORS: true })
                .then((canvas) => {
                    const imgWidth = 208
                    const imgHeight = (canvas.height * imgWidth) / canvas.width

                    const imageData = canvas.toDataURL('image/jpeg')
                    pdf.addImage(imageData, 'JPEG', 1, 0, imgWidth, imgHeight, '', 'FAST')
                })
                .catch((error) => console.error('Error capturing content:', error))
        }
    },
    watch: {
        showModal(newValue) {
            this.isModalActive = newValue
        },
        width(newValue) {
            this.widthModal = newValue
        },
        dataModal(newValue) {
            console.log('dataModal watcher invoice modal:', newValue)
            if (newValue) {
                this.invoiceData = { ...this.invoiceData, ...newValue }
                this.invoiceNumber = this.invoiceData?.installments?.[selectedPhase - 1]?.invoice_number
            }
        },
        selectedPhase(newValue) {
            console.log('dataModal watcher installmentId modal:', newValue)
            this.installmentId = newValue
        },
        typeModal(newValue) {
            this.type = newValue
        }
    }
}
</script>

<style scoped lang="scss">
@import '@/scss/_variables.scss';

.invoice-wrapper {
    max-height: 70vh;
    overflow-y: auto;
    background-color: #ffffff;
    padding: 5px;

    &::-webkit-scrollbar {
        width: 8px;
    }

    &::-webkit-scrollbar-track {
        // background: #f1f1f1;
        border-radius: 10px;
    }

    &::-webkit-scrollbar-thumb {
        background: #c1c1c1;
        border-radius: 10px;

        &:hover {
            // background: #a8a8a8;
        }
    }
}

.invoice-container {
    width: 100%;
    max-width: 500px;
    // background-color: white;
    border-radius: 24px;
    box-shadow: 0 10px 40px rgba(0, 0, 0, 0.1);
    overflow: hidden;
}

.invoice-header {
    // background-color: white;
    padding: 20px 24px;
    border-bottom: 1px solid #e5e5e5;
    text-align: center;
}

.invoice-title {
    font-size: 18px;
    font-weight: 600;
    margin: 0;
    color: #1a1a1a;
}

.invoice-content {
    padding: 24px;
}

/* Success Message */
.success-message {
    display: flex;
    gap: 12px;
    align-items: flex-start;
    margin-bottom: 24px;
}

.success-icon {
    flex-shrink: 0;
    background-color: #dc3545;
    border-radius: 50%;
    width: 32px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.message-greeting {
    font-size: 14px;
    color: #6c757d;
    margin: 0 0 4px 0;
}

.message-text {
    font-size: 14px;
    font-weight: 600;
    color: #1a1a1a;
    margin: 0;
}

/* Total Paid Box */
.total-paid-box {
    // background-color: #d4f4dd;
    border-radius: 50px;
    padding: 12px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 24px;
    background-image: url('../../assets/img/wave-3.png');
    background-size: 100% 100%;
    background-repeat: no-repeat;
    border: 1px solid #d4f4dd;
}

.currency-icon {
    width: 32px;
    height: 32px;
    background-color: #28a745;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 12px;

    span {
        color: white;
        font-weight: bold;
        font-size: 18px;
    }
}

.total-label {
    font-size: 14px;
    font-weight: 500;
    color: #495057;
}

.total-amount {
    font-size: 16px;
    font-weight: bold;
    color: #28a745;
}

/* Section */
.section {
    padding-top: 2px;
    padding-bottom: 10px;
    padding-left: 0;
    padding-right: 0;
}

.section-title {
    font-size: 16px;
    font-weight: bold;
    color: #1a1a1a;
    margin: 0 0 0px 0;
}

.section-date {
    font-size: 14px;
    color: #6c757d;
    margin: 0 0 16px 0;
}

/* Invoice Number Input */
.invoice-number-input-wrapper {
    position: relative;
    display: inline-block;
}

.invoice-number-input {
    font-size: 16px;
    font-weight: bold;
    color: #1a1a1a;
    border: 2px solid #e5e5e5;
    border-radius: 6px;
    padding: 6px 12px;
    outline: none;
    transition: all 0.3s ease;
    min-width: 250px;
    text-align: right;

    &:focus {
        border-color: #28a745;
    }

    &.error {
        border-color: #dc3545;
        color: #dc3545;
    }

    &::placeholder {
        color: #9a9a9a;
        font-weight: normal;
    }
}

.error-tooltip {
    position: absolute;
    top: 100%;
    right: 0;
    margin-top: 4px;
    background-color: #dc3545;
    color: white;
    padding: 4px 8px;
    border-radius: 4px;
    font-size: 12px;
    white-space: nowrap;
    z-index: 10;

    &::before {
        content: '';
        position: absolute;
        bottom: 100%;
        right: 12px;
        border: 5px solid transparent;
        border-bottom-color: #dc3545;
    }
}

/* Detail List */
.detail-list {
    display: flex;
    flex-direction: column;
    gap: 5px;
}

.detail-header {
    font-size: 14px;
    font-weight: 600;
    color: #495057;
}

.detail-item {
    font-size: 14px;
}

.detail-desc {
    color: #6c757d;
}

.detail-price {
    font-weight: 600;
    color: #1a1a1a;
}

.detail-order-number {
    font-size: 12px;
    color: #9a9a9a;
    margin: 0;
}

.detail-description {
    font-size: 12px;
    color: #1a1a1a;
    margin: 0
}

.detail-row {
    font-size: 14px;
    padding-left: 24px;
}

.detail-discount {
    font-weight: 600;
    color: #dc3545;
}

.detail-total {
    padding-top: 12px;
    border-top: 1px solid #e5e5e5;
    font-size: 14px;
}

.detail-total-label {
    font-weight: 600;
    color: #1a1a1a;
}

.detail-total-amount {
    font-weight: bold;
    color: #1a1a1a;
}

/* Payment Box */
.payment-box {
    background-color: #ffffff;
    border-radius: 12px;
    padding: 16px;
    display: flex;
    flex-direction: column;
    gap: 5px;
    border: 1px solid #e5e5e5;
}

.payment-row {
    font-size: 14px;
}

.payment-label {
    color: #6c757d;
}

.payment-value {
    font-weight: 600;
    color: #1a1a1a;
}

.payment-total {
    padding-top: 8px;
    border-top: 1px solid #dee2e6;
    font-size: 14px;
}

.payment-total-label {
    font-weight: bold;
    color: #1a1a1a;
}

.payment-total-value {
    font-weight: bold;
    color: #1a1a1a;
}

.payment-divider {
    border-top: 1px solid #dee2e6;
    margin: 8px 0;
}

.payment-final {
    font-size: 14px;
}

.payment-final-label {
    font-weight: bold;
    color: #1a1a1a;
}

.payment-final-value {
    text-align: right;
}

.payment-status {
    font-size: 12px;
    font-weight: 600;
    color: #28a745;
    margin-right: 8px;
}

.payment-amount {
    font-weight: bold;
    color: #1a1a1a;
}

.status-pending {
    background-color: #fff3cd;
    color: #856404;
}

.status-paid {
    background-color: #d4edda;
    color: #155724;
}

.status-expired {
    background-color: #e2e3e5;
    color: #6c757d;
}

.status-cancelled {
    background-color: #f8d7da;
    color: #721c24;
}

.form-button {
    padding: 12px;
    width: 100%;
    box-shadow: 0px -4px 16px rgba(0, 0, 0, 0.05);
}

/* --- DEFAULT BUTTON (hapus styling global yg bikin kacau) --- */
.form-button button {
    border-radius: 100px;
    font-family: 'Averta-Bold';
    padding: 24px;
}

/* --- OUTLINE RED BUTTON --- */
.btn-outline-red {
    background: transparent !important;
    border: 1px solid #E10009 !important;
    color: #E10009 !important;
    transition: 0.2s;
}

.btn-outline-red:hover,
.btn-outline-red:active {
    background: #E10009 !important;
    color: #ffffff !important;
}

/* --- FILLED RED BUTTON --- */
.btn-fill-red {
    background: #E10009 !important;
    border: 1px solid #E10009 !important;
    color: white !important;
    transition: 0.2s;
}

.btn-fill-red:hover,
.btn-fill-red:active {
    background: #B00007 !important;
    /* darker for feedback */
    border-color: #B00007 !important;
}

.red {
    color: red;
}

.green {
    color: green;
}

@media screen and (max-width: 768px) {
    .invoice-wrapper {
        padding: 8px;
    }

    .invoice-content {
        padding: 16px;
    }

    .invoice-number-input {
        min-width: 200px;
        font-size: 14px;
    }
}
</style>
